import jmc from 'jquery-minicolors';
import jmcCss from './jquery.minicolors.css';
import amc from 'angular-minicolors';

export default angular.module('eventix.common.directives.minicolors', ['minicolors'])
    .directive('injectCssInFrame', function($log) {
        return {
            restrict: 'A',
            scope: { injectCssInFrame: '=' },
            link: function(scope, el) {
                if(el.get(0).tagName !== 'IFRAME') {
                    $log.error('Use injectCssInFrame directive on an iFrame only');
                    return;
                }
                var stylesheet;
                el.on('load', function() {
                    try {
                        var document = el.get(0).contentDocument;
                        stylesheet = document.createElement('style');
                        stylesheet.innerHTML = scope.injectCssInFrame;
                        document.head.appendChild(stylesheet);
                    } catch(err) {
                        stylesheet = null;
                    }
                });
                scope.$watch('injectCssInFrame', _.debounce(() => {
                    if(stylesheet)
                        stylesheet.innerHTML = scope.injectCssInFrame;
                }, 300));
            }
        };
    })
    .component('phoneMock', {
        template: `<h3>Live preview</h3>
        <img src="/img/iphone_frame.png">
    <div class="btn-group btn-reload">
        <button type="button" ng-click="$ctrl.reload()" class="btn btn-xs btn-link"><i class="fa fa-refresh"></i></button>
        <a ng-href="{{ $ctrl.url }}" target="_BLANK" class="btn btn-xs btn-link"><i class="fa fa-external-link"></i></a>
    </div>
    <iframe ng-attr-src="{{ $ctrl.iframe }}"
            inject-css-in-frame="$ctrl.shop.css"
            border="0"></iframe>`,
        bindings: {
            shop: '=',
            nonce: '@'
        },
        controller: function($element, $sce, $scope) {
            const $ctrl = this;
            $ctrl.$postLink = function() {
                let domain = document.domain = location.hostname.split('.').slice(-2).join('.');
                let frame = $element.find('iframe');
                frame.on('load', function() {
                    try {
                        $ctrl.document = frame.get(0).contentDocument;
                    } catch(err) {
                        $ctrl.document = null;
                    }
                });
                $scope.$watch('$ctrl.shop.guid', shopGuid => {
                    if(shopGuid) {
                        $ctrl.url = FANCY_SHOP_ROOT + shopGuid;
                        $ctrl.iframe = $ctrl.url + '?preview';
                        if($ctrl.nonce)
                            $ctrl.iframe += '&nonce=' + $ctrl.nonce;
                        $ctrl.iframe = $sce.trustAsResourceUrl($ctrl.iframe);
                    } else {
                        $ctrl.url = null;
                        $ctrl.iframe = $sce.trustAsResourceUrl('data:text/html,<div></div>');
                    }
                });
                $scope.$watch('$ctrl.nonce', _.debounce(nonce => {
                    if($ctrl.shop.guid) {
                        $ctrl.url = FANCY_SHOP_ROOT + $ctrl.shop.guid;
                        $ctrl.iframe = $ctrl.url + '?preview';
                        if($ctrl.nonce)
                            $ctrl.iframe += '&nonce=' + $ctrl.nonce;
                        $ctrl.iframe = $sce.trustAsResourceUrl($ctrl.iframe);
                    } else {
                        $ctrl.url = null;
                        $ctrl.iframe = $sce.trustAsResourceUrl('data:text/html,<div></div>');
                    }
                    $scope.$apply();
                }, 3000));
            };
            $ctrl.reload = () => $ctrl.document && $ctrl.document.location.reload();
        }
    }).factory('ShopStyler', function() {
        var cssVariablesGenerator = _.template(`{
        "header": {
            "background": "#002856",
            "text": "#ffffff",
            "nav": {
                "normal": {
                    "background": "{{ primary }}",
                    "text": "#000000",
                    "number": {
                        "background": "#ffffff",
                        "text": "{{ primary }}"
                    }
                },
                "active": {
                    "background": "{{ secondary }}",
                    "text": "#ffffff",
                    "number": {
                        "background": "#ffffff",
                        "text": "{{ secondary }}"
                    }
                }
            }
        },
        "tickets": {
            "heading": {
                "background": "{{ primary }}",
                "text": "#ffffff"
            },
            "reserveBtn": {
                "background": "{{ secondary }}",
                "text": "#ffffff"
            }
        },
        "button": {
            "background": "{{ secondary }}",
            "text": "#ffffff"
        },
        "panel": {
            "title": {
                "background": "{{ primary }}",
                "text": "#ffffff"
            },
            "body": {
                "background": "#f5f5f5",
                "text": "#333333",
                "link": "#91c7eb"
            }
        },
        "coupon": {
            "display": true,
            "button": {
                "background": "#3fd5ae",
                "text": "#ffffff"
            }
        },
        "body": {
            "background": "#ffffff",
            "text": "#333333",
            "link": "#91c7eb"
        }
    }`, {
            interpolate: /{{([\s\S]+?)}}/g
        });
        let cssGenerator = _.template(`/* THIS IS AUTO-GENERATED, DO NOT EDIT */
/* You can however copy-paste settings from one shop to another */
        .checkout.breadcrumb li {
            background: {{ css.header.nav.normal.background }};
            color: {{ css.header.nav.normal.text }};
        }
        .checkout.breadcrumb li::after {
            background: {{ css.header.nav.normal.background }};
            color: {{ css.header.nav.normal.text }};
        }
        .checkout.breadcrumb li.active {
            background: {{ css.header.nav.active.background }};
            color: {{ css.header.nav.active.text }};
        }
        .checkout.breadcrumb li.active::after {
            background: {{ css.header.nav.active.background }};
            color: {{ css.header.nav.active.text }};
        }
        .checkout.breadcrumb li .number{
            color: {{ css.header.nav.normal.number.text }};
            background: {{ css.header.nav.normal.number.background }};
        }
        .checkout.breadcrumb li.active .number{
            color: {{ css.header.nav.active.number.text }};
            background: {{ css.header.nav.active.number.background }};
        }

        #shop-tickets .event-title {
            border: {{ css.tickets.heading.background }};
            background-color: {{ css.tickets.heading.background }};
            color: {{ css.tickets.heading.text }};
        }

        .app.ticket-selection .content .tickets .ticket .ticket-amount button {
            background-color: {{ css.tickets.reserveBtn.background }};
            color: {{ css.tickets.reserveBtn.text }};
        }

        .app .btn.btn-primary, .app .btn-raised.btn-primary {
            background-color: {{ css.button.background }};
            color: {{ css.button.text }};
        }

        .app .panel-group .panel-heading .panel-title {
            background-color: {{ css.panel.title.background }};
            color: {{ css.panel.title.text }};
        }
        .app .panel-group .panel-heading .panel-title a:active,
        .app .panel-group .panel-heading .panel-title a:visited,
        .app .panel-group .panel-heading .panel-title a:hover,
        .app .panel-group .panel-heading .panel-title .text-muted {
            color: {{ css.panel.title.text }};
        }

        .app .panel-group .panel-heading {
            border-color: {{ css.panel.title.background }};
        }

        .app .panel-group .panel-body {
            background-color: {{ css.panel.body.background }};
            color: {{ css.panel.body.text }};
        }
        
        .app .panel-group .panel-body a,
        .app .panel-group .panel-body a:hover,
        .app .panel-group .panel-body a:active,
        .app .panel-group .panel-body a:focus {
            color: {{ css.panel.body.link }}
        }

        .app .panel-group .panel-body .control-label,
        .app .panel-group .panel-body label,
        .app .panel-group .panel-body .radio label,
        .app .panel-group .panel-body .form-control,
        .app #content .panel-group .panel-body .control-label,
        .app #content .panel-group .panel-body label,
        .app #content .panel-group .panel-body .radio label,
        .app #content .panel-group .panel-body .form-control {
            color: {{ css.panel.body.text }};
        }

        .app .panel-group .panel-body .radio .circle,
        .app .panel-group .panel-body .radio input[type=radio]:checked ~ .circle{
            border-color: {{ css.panel.body.text }};
        }

        .app .panel-group .panel-body .radio input[type=radio]:checked ~ .check {
            background-color: {{ css.panel.body.text }};
        }

        .app .panel-body .ruler::before {
            background: {{ css.panel.body.background }}
        }

        .app .btn.btn-primary:active:not(.btn-link),
        .app .btn.btn-primary:focus:not(.btn-link),
        .app .btn.btn-primary:hover:not(.btn-link),
        .app .btn-raised.btn-primary:active:not(.btn-link),
        .app .btn-raised.btn-primary:focus:not(.btn-link),
        .app .btn-raised.btn-primary:hover:not(.btn-link),
        .app #content .info-box .btn.info-close {
            background-color: {{ css.button.background }};
            color: {{ css.button.text }};
        }

        .btn.btn-info:not(.btn-raised),
        .btn.btn-default:not(.btn-raised) {
            color: {{ css.button.background }};
        }

        .order-coupon {
          display: {{ css.coupon.display ? 'block' : 'none' }};
        }
        .fancy .order-coupon .btn.btn-coupon {
            background-color: {{ css.coupon.button.background }};
            color: {{ css.coupon.button.text }};
        }
        .app .header .top-nav, .app .footer, .app .footer .tickets-lost a, .app .footer .navbar {
            background-color: {{ css.header.background }};
            color: {{ css.header.text }};
        }

        body,
        .app .content .control-label,
        .app .content .panel-group .control-label,
        .app #content .panel-group .control-label {
            background-color: {{ css.body.background }};
            color: {{ css.body.text }};
        }
        
        body a,
        body a:hover,
        body a:active,
        body a:focus,
        body .panel-group a,
        body .panel-group a:hover,
        body .panel-group a:active,
        body .panel-group a:focus {
            color: {{ css.body.link }}
        }
        
        .modal {
            color: #333;
        }
        /* SETTINGS {{ JSON.stringify(css) }} */
        /* START:CustomCSS */
        {{ custom }}
        /* STOP:CustomCSS */
    `, {
            interpolate: /{{([\s\S]+?)}}/g
        });

        let defaults = {
            primary: '#67b2e7',
            secondary: '#ff4c00'
        };

        function quickstart(vars) {
            try {
                return JSON.parse(cssVariablesGenerator(vars || defaults));
            } catch(error) {
                console.error('Faild to quickstart shopStyle', error);
                return {};
            }
        }

        function restoreVariables(css) {
            let variables = {
                css: quickstart(),
                custom: '',
                primary: defaults.primary,
                secondary: defaults.secondary
            };
            if(!css || css.indexOf('SETTINGS') < 0) {
                variables.custom = css || '';
                return variables;
            }

            var settingsRegex = /\/\* SETTINGS (.*?)\*\//g;
            var matches = settingsRegex.exec(css);
            if(!matches || !matches.length)
                return variables;
            try {
                variables.css = _.defaultsDeep(JSON.parse(matches[1]), variables.css);
                variables.primary = _.get(
                    variables.css,
                    'header.nav.normal.background',
                    defaults.primary
                );
                variables.secondary = _.get(
                    variables.css,
                    'header.nav.active.background',
                    defaults.secondary
                );
            } catch(e) {
                variables.css = quickstart();
            }

            var customRegex = /\/\*\sSTART:CustomCSS\s\*\/([\s\S]*?)\/\*\sSTOP:CustomCSS\s\*\//m;
            matches = customRegex.exec(css);
            if(matches && matches.length)
                variables.custom = matches[1].trim();
            return variables;
        }

        return {
            cssVariablesGenerator: quickstart,
            cssGenerator: cssGenerator,
            restoreVariables: restoreVariables,
            defaults: defaults
        };
    }).name;
